/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from "rxjs";
import { AbstractResourceService, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';

@Injectable({
  providedIn: 'root'
})
export class DelLegalEntityResourceService extends AbstractResourceService<LegalEntityModel,
  LegalEntityModel,
  any,
  any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('delLegalEntityUrl'),
      LegalEntityModel,
      LegalEntityModel
    );
  }

  findAllLocalLegalEntityForVendor(query?: any, additionalParams?: any): Observable<JsonApiResource<LegalEntityModel[], any>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []).toString();
    return this.httpClient?.get(`${this.url}/for-vendor/local${queryString}`).pipe(this.mapToListOfObjects());
  }
}

